import { useMemo } from "react";
import { ClientDetails } from "src/interfaces/IClient";
import { Zone } from "src/interfaces/IZone";
import { useQuery } from "@apollo/client";
import { zoneQuery } from "src/services/graphqlService";
import { GqlTableQueryResult } from "./types";

// eslint-disable-next-line import/prefer-default-export
export function useWyndZoneQuery(
  client: ClientDetails
): GqlTableQueryResult<Zone> {
  const {
    loading: isLoading,
    refetch,
    data,
  } = useQuery(zoneQuery(client.client_dbname), {
    skip: client.client_dbname === "",
  });

  return {
    data: data?.[`${client.client_dbname}_zone`] || [],
    isLoading,
    refetch,
  };
}
